import treeSelect from './tree-select/tree-select.vue'

export default treeSelect



// WEBPACK FOOTER //
// ./src/components/index.js